<template>
  <section class="maintenance-page">
    <div class="maintenance-inner">
      <div class="maintenance-kicker">Inventario en curso</div>
      <h1>El catalogo web se encuentra en inventario</h1>
      <p>
        Estamos revisando existencias para mantener el catalogo actualizado.
        Pronto reanudaremos el servicio de compras por la web.
      </p>
      <div v-if="!ocultarWhatsapp" class="maintenance-actions">
        <a
          class="maintenance-whatsapp"
          :href="whatsappUrl"
          target="_blank"
          rel="noopener"
        >
          <i class="mdi mdi-whatsapp"></i>
          Escribir por WhatsApp
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MantenimientoCatalogo",
  props: {
    numeroWhatsapp: {
      type: String,
      default: "3243717299",
    },
    ocultarWhatsapp: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    numeroNormalizado() {
      const digitos = String(this.numeroWhatsapp || "").replace(/\D+/g, "");
      if (digitos.length === 12 && digitos.startsWith("57")) return digitos.slice(2);
      return /^3\d{9}$/.test(digitos) ? digitos : "3243717299";
    },
    whatsappUrl() {
      const mensaje = encodeURIComponent(
        "Hola, vi que el catalogo web esta en inventario y necesito informacion."
      );
      return `https://wa.me/57${this.numeroNormalizado}?text=${mensaje}`;
    },
  },
};
</script>

<style scoped>
.maintenance-page {
  min-height: calc(100vh - 180px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 72px 20px 96px;
  background:
    linear-gradient(180deg, rgba(250, 250, 249, 0.95), rgba(238, 238, 235, 0.96)),
    url("https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1800&q=80") center/cover;
}

.maintenance-inner {
  width: min(760px, 100%);
  text-align: center;
  color: #2f3437;
}

.maintenance-kicker {
  margin-bottom: 16px;
  color: #7a6a48;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.maintenance-inner h1 {
  margin: 0 auto 18px;
  max-width: 680px;
  color: #25282a;
  font-family: "Poppins", Arial, sans-serif;
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 1.13;
  letter-spacing: 0;
}

.maintenance-inner p {
  max-width: 620px;
  margin: 0 auto;
  color: #555f66;
  font-size: 1.05rem;
  line-height: 1.7;
}

.maintenance-actions {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.maintenance-whatsapp {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 46px;
  padding: 0 20px;
  border: 1px solid #1f8f55;
  border-radius: 6px;
  background: #128c4a;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.maintenance-whatsapp:hover {
  background: #0f7a40;
  border-color: #0f7a40;
  color: #fff;
}

.maintenance-whatsapp i {
  font-size: 1.25rem;
}

@media (max-width: 768px) {
  .maintenance-page {
    min-height: calc(100vh - 128px);
    align-items: flex-start;
    padding: 72px 18px 110px;
  }

  .maintenance-inner h1 {
    font-size: 1.9rem;
  }

  .maintenance-inner p {
    font-size: 1rem;
  }

  .maintenance-whatsapp {
    width: 100%;
    justify-content: center;
  }
}
</style>
